import axios from '../axios'

export default class ContactService {
  

  getLazyContacts(filterId, page, rows, sortField, sortOrder, searchText, filterbody) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/contactsfilterbypage/' + filterId + '/' + page + '/' +  rows + '/' +  sortField + '/' +  sortOrder + '/' + searchText
        var response = await axios.post(path, filterbody)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  

  getLazyContacts2(filterId, page, rows, sortField, sortOrder, searchText, filterbody) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/contactsfilterbypage2/' + filterId + '/' + page + '/' +  rows + '/' +  sortField + '/' +  sortOrder + '/' + searchText
        var response = await axios.post(path, filterbody)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  deleteContact(contactId) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/contact/' + contactId
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }
  getContact(contactId) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/contact/' + contactId
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }

  gatSavedFilteredContacts(filterId) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/savedFilteredContacts/' + filterId
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }

  contactsGlobalSearch(text) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/contactGlobalSearch/' + text
        
        var response = await axios.get(path)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    });
  }

  getContacts() {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/contacts'
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }

  getAllContacts() {
    
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/allcontacts'
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }

  getActiveNonActiveContacts(active) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/onlyactivecontacts/' + active
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }
}